/**
 * LPgenerator main API
 * API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { Http, Headers, URLSearchParams }                    from '@angular/http';
import { RequestMethod, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { Response, ResponseContentType }                     from '@angular/http';

import { Observable }                                        from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import * as models                                           from '../model/models';
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class PartnersApi {
    protected basePath = 'https://swagger.lpg/api/v1';
    public defaultHeaders: Headers = new Headers();
    public configuration: Configuration = new Configuration();

    constructor(protected http: Http, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
        }
    }

    /**
     * Создание/активация партнера
     * Активация партнера
     */
    public activatePartner(extraHttpRequestParams?: any): Observable<models.Partner> {
        return this.activatePartnerWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Создать кошелек пользователя
     * Создание кошелька пользователя
     * @param newWallet 
     */
    public createPartnersWallet(newWallet?: models.NewWallet, extraHttpRequestParams?: any): Observable<models.Wallet> {
        return this.createPartnersWalletWithHttpInfo(newWallet, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Удалить запрос на вывод средств
     * Удалить запрос на вывод средств
     * @param id id пейаута
     */
    public deletePayout(id: number, extraHttpRequestParams?: any): Observable<{}> {
        return this.deletePayoutWithHttpInfo(id, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Удалить объект кошелька пользователя
     * Удаление объекта кошелька пользователя
     * @param id id кошелька
     */
    public deleteWallet(id: number, extraHttpRequestParams?: any): Observable<{}> {
        return this.deleteWalletWithHttpInfo(id, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Выгрузить список транзакций в ексель
     * Выгрузка в ексель транзакций с возможностью фильтрации
     * @param timestampGtе Фильтр по платежам больше либо равно перереданной даты
     * @param timestampLt Фильтр по платежам меньше либо равно перереданной даты
     * @param descriptionIcontains Фильтр по описанию
     * @param ordering Сортировка по полям: timestamp, -timestamp, amount, -amount
     */
    public exportPartnersTransactions(timestampGtе?: Date, timestampLt?: Date, descriptionIcontains?: string, ordering?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2003> {
        return this.exportPartnersTransactionsWithHttpInfo(timestampGtе, timestampLt, descriptionIcontains, ordering, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получение списка промо материалов для партнера
     * Получение списка промо материалов для партнера
     */
    public getPartnerPromo(extraHttpRequestParams?: any): Observable<models.Promo> {
        return this.getPartnerPromoWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Данные для партнеров
     * Получение данных для страницы партнеров
     */
    public getPartnersData(extraHttpRequestParams?: any): Observable<models.PartnersSettings> {
        return this.getPartnersDataWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Суммарная подробная статистика партнера
     * Получение списка суммарных статистик пользователей
     * @param timestampGte Параметр для фильтрации по дате начала
     * @param timestampLt Параметр для фильтрации по дате окончания
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     */
    public getPartnersFullStatistics(timestampGte?: Date, timestampLt?: Date, offset?: number, descriptionIcontains?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2002> {
        return this.getPartnersFullStatisticsWithHttpInfo(timestampGte, timestampLt, offset, descriptionIcontains, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список выводов средств
     * Получение списка выводов средств пользователями
     * @param createdGte Фильтр по платежам которые были созданы позже либо равно перереданной даты
     * @param createdLt Фильтр по платежам которые были созданы раньше либо равно перереданной даты
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     * @param wallet Фильтр по id кошелька
     * @param status Фильтр по статусу id статуса
     * @param ordering Парамерты для сортировки: created, -created, amount, -amount, status, -status
     */
    public getPartnersPayouts(createdGte?: Date, createdLt?: Date, offset?: number, descriptionIcontains?: string, wallet?: number, status?: number, ordering?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2004> {
        return this.getPartnersPayoutsWithHttpInfo(createdGte, createdLt, offset, descriptionIcontains, wallet, status, ordering, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Суммарная статистика партнера
     * Получение списка суммарных статистик пользователей
     * @param timestampGte Параметр для фильтрации по дате начала
     * @param timestampLt Параметр для фильтрации по дате окончания
     */
    public getPartnersStatistics(timestampGte?: Date, timestampLt?: Date, extraHttpRequestParams?: any): Observable<models.PartnerStatistics> {
        return this.getPartnersStatisticsWithHttpInfo(timestampGte, timestampLt, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список транзакций
     * Получение списка транзакций с возможностью фильтрации
     * @param timestampGtе Фильтр по платежам больше либо равно перереданной даты
     * @param timestampLt Фильтр по платежам меньше либо равно перереданной даты
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     * @param ordering Сортировка по полям: timestamp, -timestamp, amount, -amount
     */
    public getPartnersTransactions(timestampGtе?: Date, timestampLt?: Date, offset?: number, descriptionIcontains?: string, ordering?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2003> {
        return this.getPartnersTransactionsWithHttpInfo(timestampGtе, timestampLt, offset, descriptionIcontains, ordering, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить список кошельков пользователя
     * Получение списка кошельков пользователя
     * @param walletType Фильтр по типу кошелька
     * @param mumberIcontains Фильтр по номеру кошелька
     */
    public getPartnersWallets(walletType?: number, mumberIcontains?: string, extraHttpRequestParams?: any): Observable<models.InlineResponse2005> {
        return this.getPartnersWalletsWithHttpInfo(walletType, mumberIcontains, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Получить объект кошелька пользователя
     * Получение объекта кошелька пользователя
     * @param id id кошелька
     */
    public getPayoutType(id: number, extraHttpRequestParams?: any): Observable<models.Wallet> {
        return this.getPayoutTypeWithHttpInfo(id, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Редактировать объект кошелька пользователя
     * Редактирование объекта кошелька пользователя
     * @param id id кошелька
     * @param wallet 
     */
    public patchWallet(id: number, wallet?: models.Wallet, extraHttpRequestParams?: any): Observable<models.Wallet> {
        return this.patchWalletWithHttpInfo(id, wallet, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Вывод средств для партнера
     * Создание транзикации
     * @param payout 
     */
    public postPartnersPayout(payout?: models.NewTransaction, extraHttpRequestParams?: any): Observable<models.Payout> {
        return this.postPartnersPayoutWithHttpInfo(payout, extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Изменение состояния баннера с активного на неактивное и наоборот
     * Изменение состояния баннера с активного на неактивное и наоборот
     */
    public switchPartnerFooterState(extraHttpRequestParams?: any): Observable<models.PromoFooter> {
        return this.switchPartnerFooterStateWithHttpInfo(extraHttpRequestParams)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }


    /**
     * Создание/активация партнера
     * Активация партнера
     */
    public activatePartnerWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/partners/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Post,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Создать кошелек пользователя
     * Создание кошелька пользователя
     * @param newWallet 
     */
    public createPartnersWalletWithHttpInfo(newWallet?: models.NewWallet, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/wallets/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        headers.set('Content-Type', 'application/json');

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Post,
            headers: headers,
            body: newWallet == null ? '' : JSON.stringify(newWallet), // https://github.com/angular/angular/issues/10612
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Удалить запрос на вывод средств
     * Удалить запрос на вывод средств
     * @param id id пейаута
     */
    public deletePayoutWithHttpInfo(id: number, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/payouts/${id}/'
                    .replace('${' + 'id' + '}', String(id));

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deletePayout.');
        }
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Delete,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Удалить объект кошелька пользователя
     * Удаление объекта кошелька пользователя
     * @param id id кошелька
     */
    public deleteWalletWithHttpInfo(id: number, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/wallets/${id}/'
                    .replace('${' + 'id' + '}', String(id));

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWallet.');
        }
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Delete,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Выгрузить список транзакций в ексель
     * Выгрузка в ексель транзакций с возможностью фильтрации
     * @param timestampGtе Фильтр по платежам больше либо равно перереданной даты
     * @param timestampLt Фильтр по платежам меньше либо равно перереданной даты
     * @param descriptionIcontains Фильтр по описанию
     * @param ordering Сортировка по полям: timestamp, -timestamp, amount, -amount
     */
    public exportPartnersTransactionsWithHttpInfo(timestampGtе?: Date, timestampLt?: Date, descriptionIcontains?: string, ordering?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/transactions/export/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (timestampGtе !== undefined) {
            queryParameters.set('timestamp__gtе', <any>timestampGtе.toISOString());
        }

        if (timestampLt !== undefined) {
            queryParameters.set('timestamp__lt', <any>timestampLt.toISOString());
        }

        if (descriptionIcontains !== undefined) {
            queryParameters.set('description__icontains', <any>descriptionIcontains);
        }

        if (ordering !== undefined) {
            queryParameters.set('ordering', <any>ordering);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получение списка промо материалов для партнера
     * Получение списка промо материалов для партнера
     */
    public getPartnerPromoWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/promo/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Данные для партнеров
     * Получение данных для страницы партнеров
     */
    public getPartnersDataWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/settings/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Суммарная подробная статистика партнера
     * Получение списка суммарных статистик пользователей
     * @param timestampGte Параметр для фильтрации по дате начала
     * @param timestampLt Параметр для фильтрации по дате окончания
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     */
    public getPartnersFullStatisticsWithHttpInfo(timestampGte?: Date, timestampLt?: Date, offset?: number, descriptionIcontains?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/statistics_full/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (timestampGte !== undefined) {
            queryParameters.set('timestamp__gte', <any>timestampGte.toISOString());
        }

        if (timestampLt !== undefined) {
            queryParameters.set('timestamp__lt', <any>timestampLt.toISOString());
        }

        if (offset !== undefined) {
            queryParameters.set('offset', <any>offset);
        }

        if (descriptionIcontains !== undefined) {
            queryParameters.set('description__icontains', <any>descriptionIcontains);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список выводов средств
     * Получение списка выводов средств пользователями
     * @param createdGte Фильтр по платежам которые были созданы позже либо равно перереданной даты
     * @param createdLt Фильтр по платежам которые были созданы раньше либо равно перереданной даты
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     * @param wallet Фильтр по id кошелька
     * @param status Фильтр по статусу id статуса
     * @param ordering Парамерты для сортировки: created, -created, amount, -amount, status, -status
     */
    public getPartnersPayoutsWithHttpInfo(createdGte?: Date, createdLt?: Date, offset?: number, descriptionIcontains?: string, wallet?: number, status?: number, ordering?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/payouts/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (createdGte !== undefined) {
            queryParameters.set('created__gte', <any>createdGte.toISOString());
        }

        if (createdLt !== undefined) {
            queryParameters.set('created__lt', <any>createdLt.toISOString());
        }

        if (offset !== undefined) {
            queryParameters.set('offset', <any>offset);
        }

        if (descriptionIcontains !== undefined) {
            queryParameters.set('description__icontains', <any>descriptionIcontains);
        }

        if (wallet !== undefined) {
            queryParameters.set('wallet', <any>wallet);
        }

        if (status !== undefined) {
            queryParameters.set('status', <any>status);
        }

        if (ordering !== undefined) {
            queryParameters.set('ordering', <any>ordering);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Суммарная статистика партнера
     * Получение списка суммарных статистик пользователей
     * @param timestampGte Параметр для фильтрации по дате начала
     * @param timestampLt Параметр для фильтрации по дате окончания
     */
    public getPartnersStatisticsWithHttpInfo(timestampGte?: Date, timestampLt?: Date, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/statistics/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (timestampGte !== undefined) {
            queryParameters.set('timestamp__gte', <any>timestampGte.toISOString());
        }

        if (timestampLt !== undefined) {
            queryParameters.set('timestamp__lt', <any>timestampLt.toISOString());
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список транзакций
     * Получение списка транзакций с возможностью фильтрации
     * @param timestampGtе Фильтр по платежам больше либо равно перереданной даты
     * @param timestampLt Фильтр по платежам меньше либо равно перереданной даты
     * @param offset Пагинация
     * @param descriptionIcontains Фильтр по описанию
     * @param ordering Сортировка по полям: timestamp, -timestamp, amount, -amount
     */
    public getPartnersTransactionsWithHttpInfo(timestampGtе?: Date, timestampLt?: Date, offset?: number, descriptionIcontains?: string, ordering?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/transactions/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (timestampGtе !== undefined) {
            queryParameters.set('timestamp__gtе', <any>timestampGtе.toISOString());
        }

        if (timestampLt !== undefined) {
            queryParameters.set('timestamp__lt', <any>timestampLt.toISOString());
        }

        if (offset !== undefined) {
            queryParameters.set('offset', <any>offset);
        }

        if (descriptionIcontains !== undefined) {
            queryParameters.set('description__icontains', <any>descriptionIcontains);
        }

        if (ordering !== undefined) {
            queryParameters.set('ordering', <any>ordering);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить список кошельков пользователя
     * Получение списка кошельков пользователя
     * @param walletType Фильтр по типу кошелька
     * @param mumberIcontains Фильтр по номеру кошелька
     */
    public getPartnersWalletsWithHttpInfo(walletType?: number, mumberIcontains?: string, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/wallets/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        if (walletType !== undefined) {
            queryParameters.set('wallet_type', <any>walletType);
        }

        if (mumberIcontains !== undefined) {
            queryParameters.set('mumber__icontains', <any>mumberIcontains);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Получить объект кошелька пользователя
     * Получение объекта кошелька пользователя
     * @param id id кошелька
     */
    public getPayoutTypeWithHttpInfo(id: number, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/wallets/${id}/'
                    .replace('${' + 'id' + '}', String(id));

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getPayoutType.');
        }
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Get,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Редактировать объект кошелька пользователя
     * Редактирование объекта кошелька пользователя
     * @param id id кошелька
     * @param wallet 
     */
    public patchWalletWithHttpInfo(id: number, wallet?: models.Wallet, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/wallets/${id}/'
                    .replace('${' + 'id' + '}', String(id));

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchWallet.');
        }
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        headers.set('Content-Type', 'application/json');

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Patch,
            headers: headers,
            body: wallet == null ? '' : JSON.stringify(wallet), // https://github.com/angular/angular/issues/10612
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Вывод средств для партнера
     * Создание транзикации
     * @param payout 
     */
    public postPartnersPayoutWithHttpInfo(payout?: models.NewTransaction, extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/payouts/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        headers.set('Content-Type', 'application/json');

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Post,
            headers: headers,
            body: payout == null ? '' : JSON.stringify(payout), // https://github.com/angular/angular/issues/10612
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

    /**
     * Изменение состояния баннера с активного на неактивное и наоборот
     * Изменение состояния баннера с активного на неактивное и наоборот
     */
    public switchPartnerFooterStateWithHttpInfo(extraHttpRequestParams?: any): Observable<Response> {
        const path = this.basePath + '/partners/footer/';

        let queryParameters = new URLSearchParams();
        let headers = new Headers(this.defaultHeaders.toJSON()); // https://github.com/angular/angular/issues/6845
        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        // to determine the Accept header
        let produces: string[] = [
            'application/json'
        ];

        let requestOptions: RequestOptionsArgs = new RequestOptions({
            method: RequestMethod.Patch,
            headers: headers,
            search: queryParameters
        });

        // https://github.com/swagger-api/swagger-codegen/issues/4037
        if (extraHttpRequestParams) {
            requestOptions = (<any>Object).assign(requestOptions, extraHttpRequestParams);
        }

        return this.http.request(path, requestOptions);
    }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/api/api/PartnersApi.ts